
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAu-UZVhX5ScmV9IyCiNcBEJ6cZgeHqwtE",
  authDomain: "needu-3f340.firebaseapp.com",
  projectId: "needu-3f340",
  storageBucket: "needu-3f340.firebasestorage.app",
  messagingSenderId: "847112031066",
  appId: "1:847112031066:web:72628698937c34fd0d8163",
  measurementId: "G-RY5X7X3S5X"
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);


